import { action } from 'typesafe-actions';

import { IFilterResult } from 'APIPackage/MainModule/interfaces/IFilterResult';

import { PmListFilterActionsEnum } from '../enums/PmListFilterActionsEnum';
import { IPmListFilter } from '../interfaces/IPmListFilter';

export interface IPmListFilterSetCurrentParams {
  current?: IPmListFilter;
  currentId?: IFilterResult['id'];
}

export const pmListFilterInit = (filterType?: string) =>
  action(PmListFilterActionsEnum.PM_LIST_FILTER_INIT, { filterType });
export const pmListFilterSetSwitcher = (value: boolean) =>
  action(PmListFilterActionsEnum.PM_LIST_FILTER_SET_SWITCHER, { value });
export const pmListFilterSetCurrent = ({ current, currentId }: IPmListFilterSetCurrentParams) =>
  action(PmListFilterActionsEnum.PM_LIST_FILTER_SET_CURRENT, { current, currentId });
export const pmListFilterGetMeta = (filterType?: string) =>
  action(PmListFilterActionsEnum.PM_LIST_FILTER_GET_META, { filterType });
export const pmListFilterSetMeta = (list: IFilterResult[]) =>
  action(PmListFilterActionsEnum.PM_LIST_FILTER_SET_META, { list });
export const pmListFilterGetData = (id: IFilterResult['id']) =>
  action(PmListFilterActionsEnum.PM_LIST_FILTER_GET_DATA, { id });
export const pmListFilterSetData = (id: IFilterResult['id'], data: IPmListFilter) =>
  action(PmListFilterActionsEnum.PM_LIST_FILTER_SET_DATA, { id, data });
export const pmListFilterCreate = (data: IPmListFilter) =>
  action(PmListFilterActionsEnum.PM_LIST_FILTER_CREATE, { data });
export const pmListFilterUpdate = (id: IFilterResult['id'], data: IPmListFilter) =>
  action(PmListFilterActionsEnum.PM_LIST_FILTER_UPDATE, { id, data });
export const pmListFilterRemove = (id: IFilterResult['id']) =>
  action(PmListFilterActionsEnum.PM_LIST_FILTER_REMOVE, { id });
export const pmListFilterSetCurrentControlOrganizations = (ids: string[]) =>
  action(PmListFilterActionsEnum.PM_LIST_FILTER_SET_CURRENT_CONTROL_ORGANIZATIONS, { ids });
export const pmListFilterSetCurrentSupervisionTypes = (ids: string[]) =>
  action(PmListFilterActionsEnum.PM_LIST_FILTER_SET_CURRENT_SUPERVISION_TYPES, { ids });
